    // plugin js file
    /**
 * Flatpickr Year Select Plugin.
 * @author Labi Romabravo
 */

/**
 *
 * @returns {Function}
 */
const yearDropdownPlugin = function (pluginConfig) {
    var defaultConfig = {
        text: '',
        theme: "light",
        date: new Date(),
        yearStart: 0,
        yearEnd: 15,

    };

    var config = {};
    for (var key in defaultConfig) {
        config[key] = pluginConfig && pluginConfig[key] !== undefined ? pluginConfig[key] : defaultConfig[key];
    }

    var getYear = function (value) {
        if (value instanceof Date && !isNaN(value.getTime())) {
            return value.getFullYear();
        }

        var date = String(value).split(/[\/-]/);
        var year = date[0].length === 4 ? date[0] : date[2];

        return parseInt(year, 10);
    }

    var currYear = new Date().getFullYear();
    var selectedYear = getYear(config.date) || currYear;

    var yearDropdown = document.createElement("select");

    var createSelectElement = function (year) {
        var start = currYear - config.yearStart;
        var end = currYear + config.yearEnd;

        // Always include a submitted date, even when it is outside the default range
        start = Math.min(start, year);
        end = Math.max(end, year);

        for (var i = start; i <= end; i++) {
            var option = document.createElement("option");
            option.value = i;
            option.text = i;
            yearDropdown.appendChild(option);
        }
        yearDropdown.value = year;
    };

    return function (fp) {
        fp.yearSelectContainer = fp._createElement(
            "div",
            "flatpickr-year-select " + config.theme + "Theme",
            config.text
        );

        fp.yearSelectContainer.tabIndex = -1;
        createSelectElement(selectedYear);
        yearDropdown.addEventListener('change', function (evt) {
            var year = parseInt(evt.target.options[evt.target.selectedIndex].value, 10);
            var selectedDate = fp.selectedDates[0];

            if (selectedDate) {
                var updatedDate = new Date(selectedDate.getTime());
                updatedDate.setFullYear(year);
                fp.setDate(updatedDate, true);
            } else {
                fp.changeYear(year);
            }
        });

        var syncYear = function () {
            yearDropdown.value = fp.currentYear;
        };

        fp.yearSelectContainer.append(yearDropdown);

        return {
            onReady: function onReady() {
                var name = fp.monthNav.className;
                const yearInputCollection = fp.calendarContainer.getElementsByClassName(name);
                const el = yearInputCollection[0];
                el.parentNode.insertBefore(fp.yearSelectContainer, el.parentNode.firstChild);
                syncYear();
            },
            onMonthChange: syncYear,
            onYearChange: syncYear,
            onValueUpdate: syncYear
        };
    };
}

export default yearDropdownPlugin
// if (typeof module !== "undefined")
//     module.exports = yearDropdownPlugin;
